package club.srams.website.pages

import androidx.compose.runtime.Composable
import club.srams.website.HeadlineTextStyle
import club.srams.website.components.layouts.PageLayoutData
import club.srams.website.toSitePalette
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textShadow
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@InitRoute
fun initPebblePupsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Pebble Pups"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun PebblePupsPage() {
    Row(HeroContainerStyle.toModifier()) {
        Box {
            val sitePalette = ColorMode.current.toSitePalette()

            Column(Modifier.gap(2.cssRem)) {
                Div(HeadlineTextStyle.toAttrs()) {
                    SpanText(
                        "Pebble Pups for ", Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                    SpanText(
                        "Junior Rockhounds",
                        Modifier
                            .color(sitePalette.brand.accent)
                            // Use a shadow so this light-colored word is more visible in light mode
                            .textShadow(0.px, 0.px, blurRadius = 0.5.cssRem, color = Colors.Gray)
                    )
                }
            }
        }

        Div(
        ) {
            Image(
                src = "/images/pebble_pups/PebblePups.png",
                alt = "Pebble Pups poster",
                modifier = Modifier.width(400.px).height(300.px)
            )
        }
    }

    HorizontalDivider(
        Modifier.fillMaxWidth()
    )

    Row() {
        Image(
            src = "/images/pebble_pups/2026_03_pebble_pups_press.jpg",
            alt = "Pebble Pups Press",
            modifier = Modifier
                .height(800.px)
                .width(900.px)
                .margin {
                    bottom(24.px)
                    top(24.px)
                }
        )
    }
}